import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// "Kaninchenbau" Portal – Silver at rest, liquid gold on hover
const GlowingPortal = ({ to, children, external = false }) => {
  const content = (
    <span className="relative inline-block group cursor-pointer">
      {/* The text itself */}
      <span
        className="relative z-10 font-serif italic text-silver transition-all duration-700 
        group-hover:text-gold"
        style={{
          textShadow: 'none',
          transition: 'color 0.7s ease, text-shadow 0.7s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.textShadow =
            '0 0 8px rgba(212,175,55,0.9), 0 0 20px rgba(212,175,55,0.6), 0 0 50px rgba(212,175,55,0.3)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.textShadow = 'none';
        }}
      >
        {children}
      </span>

      {/* Bloom layer */}
      <motion.span
        className="absolute inset-0 rounded-full pointer-events-none"
        initial={{ opacity: 0, scale: 0.8 }}
        whileHover={{ opacity: 1, scale: 1.6 }}
        transition={{ duration: 0.6 }}
        style={{
          background: 'radial-gradient(ellipse at center, rgba(212,175,55,0.15) 0%, transparent 70%)',
          filter: 'blur(8px)',
        }}
      />

      {/* Underline sweep */}
      <span
        className="absolute bottom-0 left-0 h-[1px] w-0 group-hover:w-full transition-all duration-700 ease-out"
        style={{ background: 'linear-gradient(to right, #D4AF37, #FCF6BA, #D4AF37)' }}
      />
    </span>
  );

  if (external) {
    return <a href={to} target="_blank" rel="noopener noreferrer">{content}</a>;
  }

  return <Link to={to}>{content}</Link>;
};

export default GlowingPortal;